import {
  ARTICLES_RANGE_FOR_PAGINATION,
  getSearchItem,
} from 'sly/resourceCenter/helpers';
import AuthorPage from 'sly/resourceCenter/pages/Author';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default AuthorPage;

export async function getServerSideProps({ params, resolvedUrl }) {
  const { api, store } = createApiClient(apiEndpoints);
  const { slug } = params;
  let search = '';
  if (resolvedUrl.indexOf('?') >= 0) {
    search = resolvedUrl.substring(resolvedUrl.indexOf('?'));
  }

  const [authorPromise] = await Promise.allSettled(
    [
      api.getAuthor.asAction({
        'filters[slug][$eq]': encodeURIComponent(slug),
        populate: '*',
      }),
      api.getResourceCenterCommonInfo.asAction(),
      api.getTopicHeader.asAction(),
      api.getArticle.asAction({
        'filters[author][slug][$eq]': encodeURIComponent(slug),
        'pagination[pageSize]': ARTICLES_RANGE_FOR_PAGINATION,
        'pagination[page]': getSearchItem(search, 'page-number') || 1,
        populate: '*',
        sort: 'id:desc',
      }),
    ].map(store.dispatch)
  );

  if (authorPromise?.reason?.status === 301) {
    return {
      redirect: {
        destination: authorPromise?.reason?.headers?.location,
        permanent: true,
      },
    };
  } else if (authorPromise?.value?.body?.data?.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
      params,
    },
  };
}
